import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SearchCommandActionsProps = ComponentPropsWithoutRef<'div'>;

export const SearchCommandActions = memo(
  forwardRef<HTMLDivElement, SearchCommandActionsProps>(({ className, ...restOfProps }, ref) => {
    return <div className={cn('flex items-center gap-2 ui2026:gap-1', className)} ref={ref} {...restOfProps} />;
  }),
);

SearchCommandActions.displayName = 'SearchCommandActions';
